import Phaser from 'phaser';
import { DESIGN_WIDTH, DESIGN_HEIGHT, COLORS, SCENES } from './constants';
import { BootScene } from './scenes/BootScene';
import { PreloadScene } from './scenes/PreloadScene';
import { MenuScene } from './scenes/MenuScene';
import { SettingsScene } from './scenes/SettingsScene';
import { MapScene } from './scenes/MapScene';
import { GameplayScene } from './scenes/GameplayScene';
import { ResultsScene } from './scenes/ResultsScene';
import { MapEditorScene } from './scenes/MapEditorScene';
import { AssetPreviewScene } from './scenes/AssetPreviewScene';

export const gameConfig: Phaser.Types.Core.GameConfig = {
  type: Phaser.AUTO,
  parent: 'game-container',
  width: DESIGN_WIDTH,
  height: DESIGN_HEIGHT,
  backgroundColor: COLORS.BG_DARK,
  render: {
    antialias: true,
    roundPixels: false,
    pixelArt: false,
  },
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
    min: {
      width: 960,
      height: 540,
    },
    max: {
      width: 1920,
      height: 1080,
    },
  },
  input: {
    gamepad: true,
    keyboard: true,
  },
  physics: {
    default: 'arcade',
    arcade: {
      gravity: { x: 0, y: 0 },
      debug: false,
    },
  },
  scene: [
    BootScene,
    PreloadScene,
    MenuScene,
    SettingsScene,
    MapScene,
    GameplayScene,
    ResultsScene,
    MapEditorScene,
    AssetPreviewScene,
  ],
};

// Scene key mapping for type safety
export const sceneKeys = {
  boot: SCENES.BOOT,
  preload: SCENES.PRELOAD,
  menu: SCENES.MENU,
  settings: SCENES.SETTINGS,
  map: SCENES.MAP,
  gameplay: SCENES.GAMEPLAY,
  results: SCENES.RESULTS,
  assetPreview: SCENES.ASSET_PREVIEW,
} as const;
